<template lang="pug">
aside.app-panel-wrapper
    Panel(panelClassName="segment-details")
        template(slot="header")
            sectionHeader(title="details")
                template(
                    v-if="selectedSegmentId!==null"
                    slot="action")
                    div.section-header--action
                        div.section-header--action-item.action-hidden-menu
                            svg-icon.cursor(name='dots' size="large")
                            div.menu-action-hidden--right
                                div.l-flex-row--rev.menu-action-hidden-header
                                    svg-icon(name='dots' size="large")
                                ul
                                    li.dot-menu-item(@click="editItem") Edit Segment
                                    li.dot-menu-item(@click="toggleDeleteItem(segment)") {{toggleDeleteText}}  Segment

        //- DEFAULT
        //- template(slot="content", v-if="selectedSegmentId === null")
        //-     div.info-content.scrollbar.is-scrollable
        //-         div General Information

        //- AUDIENCE DETAILS
        template(slot="content")
            //- TABS
            Tabs.info-tabs(:dataTabs="dataTabs" parent="taxonomies")

                //- TAB INFORMATION
                template(slot="content", v-if="activeTab === 'information'")
                    div.tab-content

                        section.detail-section
                            div.sub-header.l-flex-row--between
                                div.sub-header-title Details
                            div.info-content
                                div.info-block
                                    div.label ID
                                    div.value(:title="segment.id") {{ segment.id }}
                                div.info-block
                                    div.label Label
                                    div.value(:title="segment.label") {{ segment.label }}
                                div.info-block
                                    div.label Category
                                    div.value(:title="segmentCategory") {{ segmentCategory }}
                                div.info-block
                                    div.label Identifier
                                    div.value(:title="segmentCustomId") {{ segmentCustomId }}
                                div.info-block
                                    div.label Bootstrap Status
                                    div.value(:title="segmentBootstrapStatus") {{ segmentBootstrapStatus }}

                        //- RULES
                        section.detail-section(v-if="hasRule")
                            div.sub-header.l-flex-row--between
                                div.sub-header-title Rule
                            div.info-content
                                div.info-block
                                    div.label Namespace
                                    div.value(:title="segment.rule.namespace_id") {{ segment.rule.namespace_id }}
                                div.info-block.l-flex-column
                                    div.l-flex-row--between.l-align-center
                                        div.label Rule
                                        div.onoffswitch(disabled)
                                            input(
                                                type="checkbox"
                                                name="rule-status"
                                                id="rule-status"
                                                class="onoffswitch-checkbox"
                                                :false-value="'inactive'"
                                                :true-value="'active'"
                                                v-model="segmentRuleStatus"
                                            )
                                            label(class="onoffswitch-label" for="rule-status")

                                div.rule-value {{ segment.rule.rule }}

                                div.l-flex-row--between.l-align-center(v-if="enableEstimationButton")
                                    div.btn.btn--small.btn--round.btn-estimate-rule(
                                    @click="estimateRule") Estimate rule
                                    //- Loading estimation value
                                    div(v-if="isLoading")
                                        spinner(width="20" height="20")
                                    div.value(v-else) {{ ruleEstimation }}

                //- TAB FREQUENCY
                template(slot="content", v-if="activeTab === 'frequency' && accountWithFrequency")
                    div.tab-content
                        template(v-if="segment.smart_segments && segment.smart_segments.length > 0")
                            section.detail-section
                                div.sub-header.l-flex-row--between
                                    div.sub-header-title Frequency
                                div.info-content
                                    div.info-block.info-block-freq(v-for="frequency in orderedFrequencies")
                                        div.label Period
                                        div.value.l-flex-row from
                                            |
                                            div.value_from -{{ frequency.period_from }}
                                            |
                                            span to
                                            |
                                            div.value_to -{{ frequency.period_to }}
                                        //- div.info-block
                                            div.label Bootstrap
                                            div.value {{ frequencyBootstrapStatusText(frequency.bootstrap_status) }}
                            section.detail-section
                                div.btn.btn--small.btn--round.btn-new-frequency(
                                    v-if="segment.smart_segments.length < 5"
                                    @click="addFrequency()") Add period

                        section.detail-section(v-else)
                            p.no-item No frequency associated to this segment.
                            button.btn.btn--medium.btn--round.btn-rev(@click="addFrequency()") Add frequency
</template>

<script>
//avoid repeating namespace for each store action/mutation/getter/state
import { mapState, mapMutations, mapActions } from 'vuex'
import { get, head, isEmpty, isEqual, isNil, last, split, toNumber, orderBy } from 'lodash'

//components
import SectionHeader from '@/components/common/SectionHeader'
import Tabs from '@/components/common/Tabs'
import Panel from '@/components/common/Panel'

export default {
    name: 'SegmentDetails',

    props: {
        segment: { required: true, type: Object }
    },

    components: { SectionHeader, Tabs, Panel },

    watch: {
        segment: {
            handler: function(newValue, oldValue) {
                if (this.hasRule && !isEqual(oldValue, newValue)) {
                    this.ruleStatus = newValue.rule.status
                }
            },
            deep: true
        }
    },

    data() {
        return {
            ruleStatus: get(this.segment.rule, 'status', null)
        }
    },

    computed: {
        ...mapState('account', {
            bootstrapCSAvailable: state => state.settings.bootstrap_custom_segment_available,
            ruleEstimationValidated: state => state.settings.ruleActivated
        }),
        ...mapState('data/settings', {
            accountWithFrequency: state => state.general.frequency
        }),
        ...mapState('ui/manageTaxonomy', {
            activeTab: state => state.activeTab,
            dataType: state => state.selectedType,
            isLoading: state => state.isLoading.rule,
            ruleEstimations: state => state.ruleEstimations,
            selectedSegmentId: state => state.selectedSegmentId
        }),

        dataTabs() {
            return this.accountWithFrequency ? [{ label: 'information' }, { label: 'frequency' }] : [{ label: 'information' }]
        },
        hasRule() {
            return !isNil(get(this.segment, 'rule', null))
        },
        segmentBootstrapStatus() {
            return this.segment.bootstrap_status === 'unavailable' ? '-' : this.segment.bootstrap_status
        },
        segmentCategory() {
            return last(split(this.segment.key, '_'))
        },
        segmentCustomId() {
            return head(split(this.segment.key, '_'))
        },
        toggleDeleteText() {
            return this.segment.action === 'delete' ? 'Undelete' : 'Delete'
        },

        // RULE
        segmentRuleStatus: {
            get: function() {
                return this.ruleStatus
            },
            set: function(value) {
                this.ruleStatus = value
                this.setRuleStatus({ itemId: this.segment.id, status: value })
            }
        },
        isBootstrapAvailable() {
            return this.bootstrapCSAvailable && this.segment.bootstrap_status === 'unavailable'
        },
        isRuleEstimationValidated() {
            return this.ruleEstimationValidated && this.hasRule && !isEmpty(this.segment.rule.rule)
        },
        enableEstimationButton() {
            return this.isBootstrapAvailable && this.isRuleEstimationValidated
        },
        ruleEstimation() {
            return get(this.ruleEstimations, `${toNumber(this.segment.id)}`, '-')
        },

        orderedFrequencies() {
            return orderBy(this.segment.smart_segments, 'created_at')
        }
    },
    methods: {
        // Call to mutations
        ...mapMutations('ui/manageTaxonomy', ['setSegmentForm', 'setCustomSegmentData', 'setRuleStatus']),
        ...mapActions('ui/manageTaxonomy', ['retrieveRuleEstimation', 'deleteCustomSegment']),

        // CS ACTIONS: EDIT, DELETE, CREATE
        editItem() {
            this.setSegmentForm({
                displayModal: true,
                type: 'update',
                activeTab: 'information'
            })
        },

        toggleDeleteItem(node) {
            this.deleteCustomSegment({ node })
        },

        // FREQUENCY
        addFrequency() {
            this.setSegmentForm({
                displayModal: true,
                type: 'update',
                activeTab: 'frequency'
            })
        },
        // frequencyBootstrapStatusText(freq) {
        //     let statusAvailable = ['available', 'verify', 'verifying', 'verify_available', 'verify_failed']
        //     let fqStatus = ''

        //     if (freq === 'failed') fqStatus = 'failed'
        //     else if (statusAvailable.includes(freq)) fqStatus = 'available'
        //     else fqStatus = 'waiting'

        //     return fqStatus
        // },

        // RULE
        estimateRule() {
            if (this.ruleEstimation === '-') {
                this.retrieveRuleEstimation({ rule: this.segment.rule.rule, segmentId: this.segment.id })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.info-block-freq {
    margin-bottom: spacing('medium') !important;
    flex-direction: column;

    .value {
        width: 80px;
        text-align: left !important;
    }
}

.value_from,
.value_to {
    padding: 0 spacing('small');
    color: color('accent');
}
// .value_to {
//     padding-right: 0;
// }
.btn-estimate-rule {
    width: 120px;
    margin-top: 8px;
}
.rule-value {
    margin-top: 8px;
    padding: 8px;
    max-height: 200px;
    overflow: hidden;
    border: 1px solid color('separator');
    text-align: left;
    overflow-wrap: break-word;
}
</style>
